// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__2WBTT","ModalTransparent":"Modal_ModalTransparent__251ae","ModalContent":"Modal_ModalContent__2IOq7","close":"Modal_close__3rW_Y"};